import { useIntl } from "react-intl";

import {
  DrawerContent,
  DrawerTopBar,
  SwipeableDrawer,
} from "@/components/Drawer";
import type { FlightsSortValue } from "@/features/flights/types/types";

import { FlightsSort } from "./flight-filters/FlightsSort";

type Props = {
  open: boolean;
  value: FlightsSortValue;
  onSubmit: (newValue: FlightsSortValue) => void;
  onClose: () => void;
};

export const FlightsSortDrawer = ({
  open,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar
        onCloseClick={onClose}
        title={intl.formatMessage({
          defaultMessage: "Sorting",
          description:
            "Button or label to open sort options for flight results",
        })}
      />

      <DrawerContent>
        <FlightsSort value={value} onChange={onSubmit} />
      </DrawerContent>
    </SwipeableDrawer>
  );
};
